import React, {Component} from "react";
import {Col, FormControl, Row} from "react-bootstrap";

export default class PasazerInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            item:null,
            inputValueImie: '',
            inputValueNazwisko: '',
        }
        this.onChangeInputImie = this.onChangeInputImie.bind(this)
        this.onChangeInputNazwisko = this.onChangeInputNazwisko.bind(this)
    }

    onChangeInputImie(e) {
        this.setState({inputValueImie: e.target.value})
        this.props.handleChangeInputImie(this.state.item,e.target.value)
    }

    onChangeInputNazwisko(e) {
        this.setState({inputValueNazwisko: e.target.value})
        this.props.handleChangeInputNazwisko(this.state.item,e.target.value)
    }

    componentDidMount() {
        this.setState({item:this.props.item, inputValueImie:this.props.item.pasazerImie, inputValueNazwisko:this.props.item.pasazerNazwisko})
    }

    componentWillReceiveProps(nextprops) {
        this.setState({item:nextprops.item, inputValueImie:nextprops.item.pasazerImie, inputValueNazwisko:nextprops.item.pasazerNazwisko})
    }


    render() {
        return (
            <div>
                <Row>
                    <Col xs={5}>
                        <FormControl onChange={this.onChangeInputImie} defaultValue={this.state.inputValueImie} disabled={this.props.disabled} className={'inputPasazerClass'}/>
                    </Col>
                    <Col xs={7}>
                        <FormControl onChange={this.onChangeInputNazwisko} defaultValue={this.state.inputValueNazwisko} disabled={this.props.disabled} className={'inputPasazerClass'}/>
                    </Col>
                </Row>
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/dodajBiletJednorazowy/components/definiowanieZamowienia/sekcja/components/PasazerInput.js